// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download_box[data-v-652c20b0]{width:1200px;height:700px;display:flex;justify-content:space-around;align-items:center;margin:0 auto;box-sizing:border-box;margin-top:15px}.download_box img[data-v-652c20b0]{width:100%;height:100%}.download_ewm[data-v-652c20b0]{width:186px;font-size:12px;text-align:center;margin-top:9px}", ""]);
// Exports
module.exports = exports;
